export default __webpack_public_path__ + "static/media/zawodniczka1.3532bbb0.png";